import React, { useState } from 'react';
import { Button, makeStyles, Typography } from '@material-ui/core';
import * as R from 'ramda';

import { Config, ReceiptFooter } from '../Configuration';
import ReceiptFooterForm from './ReceiptFooterForm';
import ReceiptFooterList from './ReceiptFooterList';
import { useConfirmation } from 'components/Confirmation';

const useStyles = makeStyles({
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '1rem',
  },
});

interface Props {
  footers: Config['receiptFooters'];
  saveFooters(footers: ReceiptFooter[]): void;
}

function ReceiptFooters({ footers, saveFooters }: Props) {
  const styles = useStyles();
  const confirm = useConfirmation();

  const [showForm, setShowForm] = useState(false);
  const [selectedFooterId, setSelectedFooterId] = useState<string | null>(null);

  function saveEditedFooter(updatedFooter: ReceiptFooter) {
    const updatedFooterIndex = (footers ?? []).findIndex(
      footer => footer.id === updatedFooter.id,
    );
    const updatedFooters =
      updatedFooterIndex === -1
        ? (footers ?? []).concat(updatedFooter)
        : R.update(updatedFooterIndex, updatedFooter, footers);
    saveFooters(updatedFooters);
  }

  async function deleteFooter(id: ReceiptFooter['id']) {
    if (!footers) {
      // Nothing to delete, no footers exist
      return;
    }
    try {
      await confirm({
        title: 'Delete footer',
        body: 'Are you sure you want to delete this footer?',
        confirmText: 'Delete',
      });
      saveFooters(footers.filter(footer => footer.id !== id));
    } catch (error) {
      // Do nothing
    }
  }

  return (
    <div>
      <div className={styles.header}>
        <Typography variant="h6">Receipt footers</Typography>
        {!showForm ? (
          <Button
            variant="contained"
            color="secondary"
            disableElevation
            onClick={() => setShowForm(true)}
          >
            Create new footer
          </Button>
        ) : null}
      </div>
      {showForm ? (
        <ReceiptFooterForm
          footers={footers}
          selectedFooterId={selectedFooterId}
          onClose={() => {
            setShowForm(false);
            setSelectedFooterId(null);
          }}
          onSave={saveEditedFooter}
        />
      ) : (
        <ReceiptFooterList
          footers={footers}
          onEditFooter={(id: string) => {
            setSelectedFooterId(id);
            setShowForm(true);
          }}
          onDeleteFooter={deleteFooter}
        />
      )}
    </div>
  );
}

export default ReceiptFooters;
